import { Component, OnInit } from '@angular/core';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { ContactService } from './contact.service';

@Component({
  selector: 'app-contact',
  templateUrl: './contact.component.html',
  styleUrls: ['./contact.component.scss']
})
export class ContactComponent implements OnInit {

  public contactoForm: FormGroup;
  public loadingContacto: boolean;

  constructor(private contactoService: ContactService) { }

  icons = [
    {
      'img': 'information.svg',
      'tag': 'CONTACTO',
      'email': 'info@hazmatargentina.com'
    },
    {
      'img': 'capacitation.svg',
      'tag': 'CAPACITACIONES',
      'email': 'inscripciones@hazmatargentina.com'
    },
    {
      'img': 'enviroment.svg',
      'tag': 'GESTIÓN AMBIENTAL',
      'email': 'ambiente@hazmatargentina.com'
    },
    {
      'img': 'truck.svg',
      'tag': 'PROVEEDORES',
      'email': 'proveedores@hazmatargentina.com'
    }

  ];

  ngOnInit() {
    this.initForm();
  }

  initForm() {
    this.contactoForm = new FormGroup({
      nombre: new FormControl('', [Validators.required]),
      email: new FormControl('', [Validators.required, Validators.email]),
      asunto: new FormControl('', [Validators.required]),
      telefono: new FormControl('', [Validators.required]),
      mensaje: new FormControl('', [Validators.required]),
    });
  }

  sendContact() {
    this.loadingContacto = true;
    this.contactoService.sendForm(this.contactoForm.value).subscribe(
      (res: any) => {
        this.loadingContacto = false;
        alert('Mensaje enviado! Nos pondremos en contacto a la brevedad!');
        window.location.reload();
      },
      (err) => {
        console.log(err);
        this.loadingContacto = false;
      }
    );
  }

}
